import { makeObservable, observable, runInAction } from 'mobx';

import { AuthState, OktaAuth, Tokens } from '@okta/okta-auth-js';
import { WidgetOptions } from '@okta/okta-signin-widget';

import { injectable } from '@servicetitan/react-ioc';

import { environment } from '../../api';
import { IAuthStore } from '../../auth';
import logographTitanUrl from '@servicetitan/public-api-app-mgmt/src/assets/logograph-titan.png';

@injectable()
export class OktaStore implements IAuthStore {
    readonly oktaAuth = new OktaAuth({
        issuer: `${environment.okta.baseUrl}/oauth2/default`,
        clientId: environment.okta.clientId,
        redirectUri: `${window.location.origin}/login/callback`,
        scopes: ['openid', 'profile', 'email'],
        pkce: true,
    });

    readonly oktaSignInConfig: WidgetOptions = {
        baseUrl: environment.okta.baseUrl,
        clientId: environment.okta.clientId,
        redirectUri: `${window.location.origin}/login/callback`,
        authClient: this.oktaAuth,
        logo: logographTitanUrl,
        i18n: {
            en: {
                'primaryauth.title': `Sign In to\r\n${environment.site.title}`,
            },
        },
        features: {
            router: true,
        },
    };

    @observable.ref private authState: AuthState | null = null;

    constructor() {
        makeObservable(this);

        this.oktaAuth.authStateManager.subscribe((authState: AuthState) => {
            runInAction(() => {
                this.authState = authState;
            });
        });

        this.oktaAuth.start();
    }

    setTokens(tokens: Tokens): void {
        this.oktaAuth.tokenManager.setTokens(tokens);
        this.oktaAuth.authStateManager.updateAuthState();
    }

    get isAuthenticated(): boolean | null {
        return this.authState?.isAuthenticated ?? null;
    }

    get isAuthorized(): boolean {
        return true;
    }

    get canAccessWebhooks(): boolean {
        return false;
    }

    get accessToken(): string {
        return this.authState!.accessToken!.accessToken;
    }

    get userName(): string {
        return this.authState!.idToken!.claims.name!;
    }

    async signOut(): Promise<void> {
        await this.oktaAuth.signOut();
    }
}
